<div *ngIf="eventEmitterService.showSidebar == false" class="tw-w-fit tw-h-fit md:tw-hidden tw-mb-5">
  <img (click)="eventEmitterService.setShowSidebar(true)" class="tw-min-w-8 tw-min-h-8 tw-max-w-8 tw-max-h-8 tw-object-contain" src="../../../assets/menu.svg" />
</div>
